(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dl-hero-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-dl-carousel]').forEach(function (carousel) {
    const slidesEl = carousel.querySelector('[data-dl-slides]');
    const prev = carousel.querySelector('[data-dl-prev]');
    const next = carousel.querySelector('[data-dl-next]');
    const dotsEl = carousel.querySelector('[data-dl-dots]');
    if (!slidesEl) return;

    const slides = slidesEl.querySelectorAll('.dl-hero__slide');
    const total = slides.length;

    if (total <= 1) {
      // Single slide: hide nav + dots
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      if (dotsEl) dotsEl.style.display = 'none';
      return;
    }

    // Build dots
    if (dotsEl) {
      for (let i = 0; i < total; i++) {
        const d = document.createElement('button');
        d.type = 'button';
        d.className = 'dl-hero__dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Aller à l\'image ' + (i + 1));
        d.addEventListener('click', function () { goTo(i); });
        dotsEl.appendChild(d);
      }
    }

    function currentIndex() {
      const sw = slidesEl.clientWidth;
      if (!sw) return 0;
      return Math.round(slidesEl.scrollLeft / sw);
    }

    function goTo(index) {
      const sw = slidesEl.clientWidth;
      slidesEl.scrollTo({ left: index * sw, behavior: 'smooth' });
    }

    function updateState() {
      const idx = currentIndex();
      if (dotsEl) {
        dotsEl.querySelectorAll('.dl-hero__dot').forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }
      if (prev) prev.setAttribute('aria-disabled', idx <= 0 ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', idx >= total - 1 ? 'true' : 'false');
    }

    prev && prev.addEventListener('click', function () {
      goTo(Math.max(0, currentIndex() - 1));
    });

    next && next.addEventListener('click', function () {
      goTo(Math.min(total - 1, currentIndex() + 1));
    });

    let scrollTimer;
    slidesEl.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateState, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      // Maintain index on resize
      const idx = currentIndex();
      goTo(idx);
    }, { passive: true });

    updateState();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-pack-picker"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-dl-pack-picker]').forEach(function (section) {
    const form = section.querySelector('[data-dl-pack-form]');
    if (!form) return;

    const variantInput = form.querySelector('[data-dl-variant-input]');
    const quantityInput = form.querySelector('[data-dl-quantity-input]');
    const ctaPrice = form.querySelector('[data-dl-cta-price]');
    const returnToInput = form.querySelector('input[name="return_to"]');
    const ctaBtn = form.querySelector('[data-dl-submit-pack]');
    const ctaLabel = form.querySelector('.dl-packs__cta-label');

    function getCheckedSize() {
      return form.querySelector('input[name="dl-size-choice"]:checked');
    }

    function getCheckedPack() {
      return form.querySelector('input[name="dl-pack-choice"]:checked');
    }

    function updateForm() {
      const checkedSize = getCheckedSize();
      const checkedPack = getCheckedPack();

      // 1. Update variant ID from selected size's data-variant-id
      if (checkedSize && variantInput) {
        const vId = checkedSize.dataset.variantId;
        if (vId && vId !== 'null' && vId !== '') {
          variantInput.value = vId;
        }
      }

      // 2. Update quantity from selected pack's data-pack-quantity
      if (checkedPack && quantityInput) {
        const qty = parseInt(checkedPack.dataset.packQuantity, 10) || 1;
        quantityInput.value = qty;
      }

      // 2bis. Apply the right discount code at checkout for the selected pack
      if (checkedPack && returnToInput) {
        const code = (checkedPack.dataset.packDiscount || '').trim();
        returnToInput.value = code
          ? '/discount/' + encodeURIComponent(code) + '?redirect=/checkout'
          : '/checkout';
      }

      // 3. Update CTA price display
      if (checkedPack && ctaPrice) {
        const pack = checkedPack.closest('[data-dl-pack]');
        if (pack) {
          const priceEl = pack.querySelector('.dl-pack__price');
          if (priceEl) ctaPrice.textContent = priceEl.textContent.trim();
        }
      }

      // 4. Disable CTA if no size selected or size is out of stock
      if (ctaBtn) {
        if (!checkedSize || checkedSize.disabled) {
          ctaBtn.disabled = true;
          ctaBtn.classList.add('is-disabled');
          if (ctaLabel) ctaLabel.textContent = 'Choisissez une taille';
        } else {
          ctaBtn.disabled = false;
          ctaBtn.classList.remove('is-disabled');
          if (ctaLabel) ctaLabel.textContent = ctaLabel.dataset.defaultLabel || 'Commander maintenant';
        }
      }
    }

    // Memoize default label
    if (ctaLabel && !ctaLabel.dataset.defaultLabel) {
      ctaLabel.dataset.defaultLabel = ctaLabel.textContent.trim();
    }

    form.addEventListener('change', updateForm);
    updateForm();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sticky = document.querySelector('[data-dl-sticky]');
  if (!sticky) return;

  let isVisible = false;
  let scrollY = window.scrollY;

  function update() {
    const trigger = window.innerHeight * 0.9;
    const currentY = window.scrollY;
    const shouldShow = currentY > trigger;

    if (shouldShow !== isVisible) {
      isVisible = shouldShow;
      if (shouldShow) {
        sticky.hidden = false;
        requestAnimationFrame(function () {
          sticky.setAttribute('aria-hidden', 'false');
        });
      } else {
        sticky.setAttribute('aria-hidden', 'true');
        setTimeout(function () {
          if (!isVisible) sticky.hidden = true;
        }, 350);
      }
    }
    scrollY = currentY;
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-dl-testimonials]').forEach(function (track) {
    const list = track.querySelector('.dl-test__list');
    const prev = track.querySelector('[data-dl-test-prev]');
    const next = track.querySelector('[data-dl-test-next]');
    if (!list) return;

    function scrollBy(dir) {
      const card = list.querySelector('.dl-test__card');
      if (!card) return;
      const cardWidth = card.getBoundingClientRect().width + 14;
      list.scrollBy({ left: dir * cardWidth, behavior: 'smooth' });
    }

    prev && prev.addEventListener('click', function () { scrollBy(-1); });
    next && next.addEventListener('click', function () { scrollBy(1); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
